import React, { useEffect, useState } from 'react';
import { LeadModel, SPLeadModel, SimulatorOfferModel, TreatmentModel } from '../models/superbit-api-models';
import moment from 'moment';
import { LeadTreatment } from '../_LeadTreatment';
import LeadOffer from './_LeadOffer';

type Props = {
    data: SPLeadModel;
    config?: any;
    actions?: Function[]
};

const LeadItemRowDetails =(props: Props)=> {
    const [vehicle, setVehicle] = useState<any | null>(props.data.lead && props.data.lead.vehicle ? props.data.lead.vehicle : null);
    const [lead, setLead] = useState<LeadModel>(new LeadModel());
    const [offersList, setOffersList] = useState<any[]>([]);
    const [offerSortBy, setOfferSortBy] = useState<any>({
        column: 'offerIdentity',
        direction: 'ASC'
    })

    
    const buildOffersList = () => {
        if (lead && lead!=null && lead!=null &&  lead.offers!=null) {
            const offersList: any[] = lead.offers;
            setOffersList(offersList);
        }
    }

    const sortOffers = () => {
        if (lead) {
            const leadData = lead
            const offers = lead.offers;
            const offersSort = offerSortBy;
            if (offers) {
                offers.sort((a: any, b:any) => {
                    return offersSort.direction == 'ASC' ? a[offersSort.column] - b[offersSort.column] : b[offersSort.column] - a[offersSort.column];
                });
                
                leadData.offers = offers;
                setOffersList(offers);
                setLead(leadData);
            }

        }
    }

    const emptyFunc = (value?: string) => {}
    
    useEffect(()=> {
        console.log('lead Data', props.data.lead);

        if (props.data.lead) {
            setLead(props.data.lead)
        }
    },[props])

    useEffect(()=>{
        // buildOffersList();
        sortOffers();
    },[lead])

    return (<>
        <div className='lead-item-details'>
                <div className="details-row">
                    <div className="row-title">רכב</div>
                    <div className="lead-main-details flex-space-between">
                        <div className="cell">
                            <div className="title">
                                שנה
                            </div>
                            <div className="description cell-value phone-number">
                            {vehicle && vehicle.vehicleSubModel!=null ? vehicle.carYear : ''}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                קוד דגם
                            </div>
                            <div className="description cell-value phone-number">
                            {vehicle && vehicle!=null && vehicle.vehicleSubModel && vehicle.vehicleSubModel.modelCode != '' ? vehicle.vehicleSubModel.modelCode :(
                                <>
                                
                                </>
                            )}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                מ. רישוי
                            </div>
                            <div className="description cell-value phone-number">
                                {vehicle && vehicle.licenseNumber!=null && vehicle.licenseNumber!='' ? vehicle.licenseNumber: (
                                    <>
                                    &nbsp;
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="cell no-overflow lead-additions">
                            <div className="title">
                                מיגון
                            </div>
                            <div className="cell-value">
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                יצרן
                            </div>
                            <div className="description cell-value phone-number">
                            {vehicle && vehicle.manufacturer!=null ? vehicle.manufacturer.name :
                            <>
                                &nbsp;
                            </>}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                דגם
                            </div>
                            <div className="description cell-value phone-number">
                            {vehicle && vehicle.vehicleModel!=null ? vehicle.vehicleModel.name:""}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                תת דגם
                            </div>
                            <div className="description cell-value phone-number">
                            {vehicle && vehicle.vehicleSubModel!=null ? vehicle.vehicleSubModel.name:""}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                ת. מסירה
                            </div>
                            <div className="description cell-value phone-number">
                            {moment(lead.deliveryDate).format('DD-MM-YYYY')}                            
                            </div>
                        </div>
                    </div>
                    <div className="flex-space-between flex-centered flex-top lead-comment-container">
                        <div className="cell">
                            &nbsp;
                        </div>
                        <div className='cell long lead-comment'>
                            <div className="titleRowEdit ">
                                הערת המפנה
                            </div>
                            <div className="comments">
                                {lead.comment}
                            </div>
                        </div>
                        <div className="cell">
                            &nbsp;
                        </div>
                        <div className='cell long lead-comment'>
                            <div className="titleRowEdit ">
                                הערה פנימית
                            </div>
                            <div className="comments">
                                {lead.internalComment}
                            </div>
                        </div>
                    </div>
                    <div className="details-row no-padding offers">
                        <div className="row-title">
                            הצעות
                        </div>
                        <div id="offersTbl" className="content-table-header flex-centered flex-space-between">
                            <div className="cell status pointer" onClick={()=>{}}>
                                מס'
                                {/* {
                                    this.state.offerSortBy.column == 'offerIdentity' ? (
                                    <div className={`icon sort ${
                                        this.state.offerSortBy && this.state.offerSortBy.column == 'offerIdentity' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                    }`}></div>
                                    ) : (<></>)
                                } */}
                            </div>
                            <div className="cell date flex-centered flex-space-between pointer" onClick={()=>{}}>
                                ת. יצירה
                                {/* {
                                    this.state.offerSortBy.column == 'startDate' ? (
                                    <div className={`icon sort ${
                                        this.state.offerSortBy && this.state.offerSortBy.column == 'startDate' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                    }`}></div>
                                    ) : (<></>)
                                } */}
                            </div>
                            <div className="cell date flex-centered flex-space-between pointer" onClick={()=>{}}>
                                ת. תחילה
                                {/* {
                                    this.state.offerSortBy.column == 'endDate' ? (
                                    <div className={`icon sort ${
                                        this.state.offerSortBy && this.state.offerSortBy.column == 'endDate' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                    }`}></div>
                                    ) : (<></>)
                                } */}
                            </div>
                            <div className="cell date flex-centered flex-space-between pointer" onClick={()=>{}}>
                                ת. סיום
                                {/* {
                                    this.state.offerSortBy.column == 'createdDate' ? (
                                    <div className={`icon sort ${
                                        this.state.offerSortBy && this.state.offerSortBy.column == 'createdDate' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                    }`}></div>
                                    ) : (<></>)
                                } */}
                            </div>
                            <div className="cell pointer short-cell" onClick={()=>{}}>
                                גיל עיקרי 
                                {/* {
                                    this.state.offerSortBy.column == 'driverMainAge' ? (
                                    <div className={`icon sort ${
                                        this.state.offerSortBy && this.state.offerSortBy.column == 'driverMainAge' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                    }`}></div>
                                    ) : (<></>)
                                } */}
                            </div>
                            <div className="cell pointer short-cell" onClick={()=>{}}>
                                גיל צעיר
                                {/* {
                                    this.state.offerSortBy.column == 'driverYoungAge' ? (
                                    <div className={`icon sort ${
                                        this.state.offerSortBy && this.state.offerSortBy.column == 'driverYoungAge' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                    }`}></div>
                                    ) : (<></>)
                                } */}
                            </div>
                            <div className="cell pointer short-cell" onClick={()=>{}}>
                                מספר נהגים
                                {/* {
                                    this.state.offerSortBy.column == 'driverYoungAge' ? (
                                    <div className={`icon sort ${
                                        this.state.offerSortBy && this.state.offerSortBy.column == 'driverYoungAge' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                    }`}></div>
                                    ) : (<></>)
                                } */}
                            </div>
                            <div className="cell wide pointer car-model" onClick={()=>{}}>
                                דגם רכב
                                {/* {
                                    this.state.offerSortBy.column == 'vehicleSubModel' ? (
                                    <div className={`icon sort ${
                                        this.state.offerSortBy && this.state.offerSortBy.column == 'vehicleSubModel' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                    }`}></div>
                                    ) : (<></>)
                                } */}
                            </div>
                            <div className="cell pointer insurance-company" onClick={()=>{}}>
                                חברה 
                                {/* {
                                    this.state.offerSortBy.column == 'insuranceCompany' ? (
                                    <div className={`icon sort ${
                                        this.state.offerSortBy && this.state.offerSortBy.column == 'insuranceCompany' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                    }`}></div>
                                    ) : (<></>)
                                } */}
                            </div>
                            <div className="cell price pointer" onClick={()=>{}}>
                                חובה 
                                {/* {
                                    this.state.offerSortBy.column == 'compulsoryPremium' ? (
                                    <div className={`icon sort ${
                                        this.state.offerSortBy && this.state.offerSortBy.column == 'compulsoryPremium' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                    }`}></div>
                                    ) : (<></>)
                                } */}
                            </div>
                            <div className="cell price pointer" onClick={()=>{}}>
                                קסקו 
                                {/* {
                                    this.state.offerSortBy.column == 'cascoPremium' ? (
                                    <div className={`icon sort ${
                                        this.state.offerSortBy && this.state.offerSortBy.column == 'cascoPremium' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                    }`}></div>
                                    ) : (<></>)
                                } */}
                            </div>
                            <div className="cell price pointer" onClick={()=>{}}>
                                חבילות 
                                {/* {
                                    this.state.offerSortBy.column == 'ridersSum' ? (
                                    <div className={`icon sort ${
                                        this.state.offerSortBy && this.state.offerSortBy.column == 'ridersSum' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                    }`}></div>
                                    ) : (<></>)
                                } */}
                            </div>
                            <div className="cell price pointer" onClick={()=>{}}>
                                סה"כ 
                                {/* {
                                    this.state.offerSortBy.column == 'totalSum' ? (
                                    <div className={`icon sort ${
                                        this.state.offerSortBy && this.state.offerSortBy.column == 'totalSum' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                    }`}></div>
                                    ) : (<></>)
                                } */}
                            </div>
                            <div className="cell offer-button-cell actions">
                            
                            </div>
                        </div>
                        {offersList && offersList!=null? offersList.map((offer: SimulatorOfferModel, index: number) =>{
                            return (
                                <>
                                    <LeadOffer
                                        offer={offer}
                                        getAuthorizedToDriveName={emptyFunc}
                                        key={index}
                                        emailAddress={lead && lead && lead.email ? lead.email : ''}
                                        onRefreshData={()=>emptyFunc()}
                                        openPopupMessage={(d:any)=>emptyFunc(d)}
                                        OpenProduction={""}
                                    ></LeadOffer>                        
                                </>
                                )
                            }):""}
                    
                    
                    </div>
                    <div className="details-row no-padding treatments-list">
                        <div className="row-title">
                        טיפול שוטף
                        </div>
                        <div className="content-table-header flex-centered flex-space-between">
                            <div className="cell date flex-centered flex-space-between">
                                תאריך אירוע
                                <div className="icon sort"></div>
                            </div>
                            <div className="cell status">
                                סוג
                            </div>
                            <div className="cell text-label">
                                נושא
                            </div>
                            <div className="cell long">
                                הערות
                            </div>
                            <div className="cell actions">
                                
                            </div>
                        </div>
                        {lead && lead.treatments && lead.treatments.map((treatment: TreatmentModel, index: number) =>{
                            return(
                                <>
                                    <LeadTreatment treatment={treatment} key={index}></LeadTreatment>
                                </>
                            )
                        })}
                    
                        
                        
                    </div>
                </div>
        </div>
    </>)
}

export default LeadItemRowDetails;